import { createApp } from "vue";
import App from "@/App.vue";

//vuex
import store from "@/store";

//router
import router from "./router";

//백그라운드 비디오
import { Plugin } from "vue-responsive-video-background-player";

import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";

const app = createApp(App).use(router);
app.use(store);
app.use(Plugin);
app.use(VueVideoPlayer);
app.mount("#app");
